<template>
  <div class="row user-profile">
        <div class="col-12 tit_page">
            <div class="float-left">
                <h1>Meu Perfil</h1>
            </div>
            <div class="back float-right text-right">
                <a @click="$router.go(-1)" href="javascript:;" title="Voltar">
                    <i class="back">&nbsp;</i> <span>Voltar</span>
                </a>
            </div>
            <div class="clearfix"></div>
             <hr class="divider">
        </div>
        <div class="col-12 col-lg-2 text-center d-border">
            <div class="profile-image rounded-circle" style="background: -webkit-gradient(linear, right bottom, left top, from(#434371), to(#0f8b8d))">
                <div class="d-flex justify-content-center align-items-center flex-column">
                    <a class="btn btn-link" style="font-size: 60px;">{{PrimeiraLetra()}}</a>
                </div>
                <!-- <img src="../assets/images/liza.jpg" alt=""> -->
            </div>
            <div class="profile-options">
                <ul>
                    <li>
                        <router-link to="dados-pessoais" class="d-flex justify-content-between">
                            <span>
                                Dados Pessoais
                            </span>
                            <i class="icon md icon-go-2"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="configuracoes" class="d-flex justify-content-between">
                            <span>
                                Configurações
                            </span>
                            <i class="icon md icon-go-2"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="documentos" class="d-flex justify-content-between">
                            <span>
                                Documentos
                            </span>
                            <i class="icon md icon-go-2"></i>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/investimentos/minhas-ccbs" class="d-flex justify-content-between">
                            <span>Formalizações</span>
                            <i class="icon md icon-go-2"></i>
                        </router-link>
                    </li>
                    <li style="display:none;">
                        <router-link to="historico" class="d-flex justify-content-between" >
                            <span>
                                Histórico
                            </span>
                            <i class="icon md icon-go-2"></i>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12 col-lg-10">
            <transition name="fade" mode="out-in">
                <router-view  />
            </transition>
        </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/styles/iouu/variables";
@import "../assets/styles/iouu/mixins";


    .user-profile {


        .d-border {
            border-right: 1px solid #dddddd;

            @include brkp-01(1199px){
                border: none;
            }
        }

        @include xs {
            .tit_page {
                padding-bottom: 0px;
            }
            .profile-image {
                display:none;
            }
            .profile-options {
                margin:0px;
            }
        }
    }
</style>

<script>
    export default {
        methods: {
            Nome() {
                var nome = "";

                if(this.User.name == undefined || this.User.name == null || this.User.name == "") {
                    nome = this.User.username
                } else {
                    nome = this.User.name;
                }
                nome = nome.trim();
                return nome;
            },

            PrimeiraLetra() {
                var nome = this.Nome();

                return nome.length > 0 ? nome[0] : "?";
            },
            //tagueamento GA
            taggingGA() {
                this.$ga.page({
                    page: '/perfil',
                    title: 'perfil',
                })
            },
        },
        computed: {
            User: function() {
                return this.$store.state.currentUser;
            }
        }, beforeCreate() {

      window.document.title= 'Dashboard IOUU';
   },
   async created() {
        //tagueamento GA
        await this.taggingGA();
   },
}
</script>



// WEBPACK FOOTER //
// src/views/Profile.vue